import { Link } from "react-router-dom";

export const EducationPersonalConst = {
  path: "/single-page/education-personal",
  title: "Очное образование",
  contentJSX: (
    <>
      <h2>ОЧНАЯ ФОРМА ОБУЧЕНИЯ НА МАЛЬТЕ</h2>
      <p>
        <strong>Очное обучение</strong> — это идеальный выбор для тех, кто хочет получить максимум от университетской жизни. Обучение
        проходит в современном кампусе в Гзире, в самом центре Мальты, и сочетает академическую строгость с настоящим европейским
        студенческим опытом.
      </p>
      <br />
      <p>
        <strong>Очная форма обучения включает:</strong>
      </p>
      <ul>
        <li>Участие в лекциях, семинарах и интерактивных практикумах;</li>
        <li>Регулярное общение с преподавателями, кураторами и экспертами из Европы;</li>
        <li>Работа в лабораториях, симуляционных медицинских центрах и проектных группах;</li>
        <li>Доступ ко всем ресурсам кампуса: библиотекам, IT-центрам, зонам отдыха и коворкингам;</li>
        <li>Проживание в комфортабельных общежитиях недалеко от кампуса;</li>
        <li>Активную студенческую жизнь, мероприятия, экскурсии и международное сообщество;</li>
        <li>Постоянную языковую практику — улучшение английского в реальной среде;</li>
        <li>Возможность проходить стажировки в европейских клиниках, компаниях и НКО.</li>
      </ul>
      <p>
        Учёба на Мальте — это не только знания, но и культурный обмен, международные знакомства и первый серьёзный шаг к карьере за
        границей.
      </p>
      <br />
      <p>
        <strong>Очное обучение подойдёт тем, кто:</strong>
      </p>
      <ul>
        <li>Хочет учиться в ЕС и получить престижный международный диплом;</li>
        <li>Стремится к живому общению, командной работе и международной интеграции;</li>
        <li>Рассматривает Мальту как стартовую площадку для жизни и карьеры в Европе;</li>
        <li>Готов к новому опыту, путешествиям и расширению горизонтов.</li>
      </ul>
      <p>
        <strong>Мальта</strong> — это безопасная, дружелюбная страна с мягким климатом, прекрасной инфраструктурой и богатым культурным
        наследием. Идеальное место для учёбы и жизни!
      </p>
      <br />
      <p>Готовы начать?</p>
      <br />
      <Link to={"/apply-online"} className="btn-default reverse">
        Оставить заявку
      </Link>
    </>
  ),
  contentSearch: `
    ОЧНАЯ ФОРМА ОБУЧЕНИЯ НА МАЛЬТЕ
    Очное обучение — это идеальный выбор для тех, кто хочет получить максимум от университетской жизни. Обучение проходит в современном кампусе в Гзире, в самом центре Мальты, и сочетает академическую строгость с настоящим европейским студенческим опытом.
    Очная форма обучения включает:
    Участие в лекциях, семинарах и интерактивных практикумах;
    Регулярное общение с преподавателями, кураторами и экспертами из Европы;
    Работа в лабораториях, симуляционных медицинских центрах и проектных группах;
    Доступ ко всем ресурсам кампуса: библиотекам, IT-центрам, зонам отдыха и коворкингам;
    Проживание в комфортабельных общежитиях недалеко от кампуса;
    Активную студенческую жизнь, мероприятия, экскурсии и международное сообщество;
    Постоянную языковую практику — улучшение английского в реальной среде;
    Возможность проходить стажировки в европейских клиниках, компаниях и НКО.
    Учёба на Мальте — это не только знания, но и культурный обмен, международные знакомства и первый серьёзный шаг к карьере за границей.
    Очное обучение подойдёт тем, кто:
    Хочет учиться в ЕС и получить престижный международный диплом;
    Стремится к живому общению, командной работе и международной интеграции;
    Рассматривает Мальту как стартовую площадку для жизни и карьеры в Европе;
    Готов к новому опыту, путешествиям и расширению горизонтов.
    Мальта — это безопасная, дружелюбная страна с мягким климатом, прекрасной инфраструктурой и богатым культурным наследием. Идеальное место для учёбы и жизни!
    Готовы начать?
  `,
};
